import { ContentBlock, EditorState, SelectionState, genKey } from "draft-js";
import { List, OrderedSet } from "immutable";

/**
 * Copyright (c) 2016 Icelab. License: MIT
 * @link https://github.com/icelab/draft-js-block-breakout-plugin
 */
export default function resetBlockStyle(
  editorState,
  selection,
  contentState,
  currentBlock,
  blockType
) {
  const emptyBlockKey = genKey();

  const emptyBlock = new ContentBlock({
    key: emptyBlockKey,
    text: "",
    type: blockType,
    depth: 0,
    characterList: List(),
    inlineStyleRanges: [],
  });

  const blockMap = contentState.getBlockMap();

  const blocksBefore = blockMap.toSeq().takeUntil(maybeBlock => maybeBlock === currentBlock);
  const blocksAfter = blockMap
    .toSeq()
    .skipUntil(maybeBlock => maybeBlock === currentBlock)
    .rest();

  const nextBlocks = blocksBefore
    .concat([[currentBlock.getKey(), currentBlock], [emptyBlockKey, emptyBlock]], blocksAfter)
    .toOrderedMap();

  const newContentState = contentState.merge({
    blockMap: nextBlocks,
    selectionBefore: selection,
    selectionAfter: selection.merge({
      anchorKey: emptyBlockKey,
      anchorOffset: 0,
      focusKey: emptyBlockKey,
      focusOffset: 0,
      isBackward: false,
    }),
  });

  const resetState = EditorState.push(editorState, newContentState, "split-block");
  const emptySelection = SelectionState.createEmpty(emptyBlockKey);

  return EditorState.setInlineStyleOverride(
    EditorState.forceSelection(resetState, emptySelection),
    OrderedSet([])
  );
}
